var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"content":_vm.content,"footer":_vm.footer}},[_c('div',{staticClass:"block w-4 h-4 ml-2",class:{
      'text-dark-mode-15': _vm.level == 'info',
      'text-warning': _vm.level == 'alert'
    }},[(_vm.level == 'info')?_c('inline-svg',{attrs:{"src":"/img/icons/info.svg"}}):_vm._e(),(_vm.level == 'alert')?_c('inline-svg',{attrs:{"src":"/img/icons/alert.svg"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }